import ApplicationRecord from './ApplicationRecord';
import Link from './Link';
import ImageRecord from './ImageRecord';
/**
 * Emploi page.
 *
 *
 */
export default class EmploiPage
  extends ApplicationRecord({
    /**
   * @type {Number}
   */
    ID: -1,
    /**
     * @type {String}
     */
    Path: '',
    /**
     * Absolute path.
     * @type {String}
     */
    URL: '',
    /**
     * @type {String}
     */
    Title: '',
    /**
     * @type {String}
     */
    Content: '',
    /**
     * @type {Boolean}
     */
    ShowInMenus: false,

    /**
     * @type {Object}
     */
    _embedded: {},
  }) {
  /**
   * Get the hero image
   * @return {ImageRecord}
   */
  heroCaption() {
    return '' + this._getOne('HeroText', String);
  }

  /**
   * Get the hero image
   * @return {ImageRecord}
   */
  heroImage() {
    return this._getOne('HeroImg', ImageRecord).set('alt', this.HeroCaption);
  }

  /**
   * Get the hero image for mobile screen
   * @return {ImageRecord}
   */
  heroMobileImage() {
    return this._getOne('HeroMobileImg', ImageRecord).set(
      'alt',
      this.HeroCaption
    );
  }

  /**
   * Return some cards, that are just Links without links.
   * @return {List<Link>}
   */
  cards() {
    return this._getMany('Cards', p => new Link(p));
  }
}



// WEBPACK FOOTER //
// ./src/models/EmploiPage.js